import React from 'react';
import cx from 'classnames';
export const Card = ({ className = '', children }) => {
    return React.createElement("div", { className: cx('card', className) }, children);
};
//# sourceMappingURL=Card.js.map